<template>
  <div>
    <div class="solution-share-message" v-if="isClipboardEnabled">
      <label>Message</label>
      <button class="button-icon button--submit" @click="copyToClipboard()">Copy to clipboard<i class="icon-copy"></i></button>
    </div>

    <div class="editor">
      <editor-menu-bubble :editor="editor" :keep-in-bounds="keepInBounds" v-slot="{ commands, isActive, getMarkAttrs, menu }">
        <div
          class="menububble"
          :class="{ 'is-active': menu.isActive }"
          :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
        >
          <form class="menububble__form menububble-main" v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(commands.link, linkUrl)">
            <input class="menububble__input" type="text" v-model="linkUrl" placeholder="https://" ref="linkInput" @keydown.esc="hideLinkMenu"/>
            <button class="menububble__button" @click="setLinkUrl(commands.link, null)" type="button">
              x
            </button>
          </form>
          <div v-else class="menububble-main">
            <button
              class="menububble-button menububble-button--h"
              @click="toggleDropdown()"
              :class="{ 'is-active': displayDropDown }"
            ></button>

            <button
              class="menububble-button menububble-button--p"
              :class="{ 'is-active': isActive.paragraph() }"
              @click="commands.paragraph"
            >
              P
            </button>

            <button
              class="menububble-button menububble-button--ul"
              :class="{ 'is-active': isActive.bullet_list() }"
              @click="commands.bullet_list"
            ></button>

            <button
              class="menububble-button menububble-button--ol"
              :class="{ 'is-active': isActive.ordered_list() }"
              @click="commands.ordered_list"
            >
              OL
            </button>

            <button
              class="menububble-button menububble-button--quote"
              :class="{ 'is-active': isActive.blockquote() }"
              @click="commands.blockquote"
            ></button>

            <button
              class="menububble-button menububble-button--b"
              :class="{ 'is-active': isActive.bold() }"
              @click="commands.bold"
            ></button>

            <button
              class="menububble-button menububble-button--i"
              :class="{ 'is-active': isActive.italic() }"
              @click="commands.italic"
            ></button>

            <button
              class="menububble-button menububble-button--link"
              @click="showLinkMenu(getMarkAttrs('link'))"
              :class="{ 'is-active': isActive.link() }"
            >
              <!--            <span>{{ isActive.link() ? 'Update Link' : 'Add Link'}}</span>-->
            </button>

            <!--          <button-->
            <!--            class="menububble-button menububble-button&#45;&#45;image"-->
            <!--            @click="showImagePrompt(commands.image)"-->
            <!--          ></button>-->
          </div>

          <div class="menububble-dropdown" v-show="displayDropDown">

            <button
              class="menububble-button"
              :class="{ 'is-active': isActive.heading({ level: 1 }) }"
              @click="commands.heading({ level: 1 })"
            >
              <span class="menububble-button-label">H1</span>
              <span class="menububble-button-sample h1">Heading 1</span>
            </button>

            <button
              class="menububble-button"
              :class="{ 'is-active': isActive.heading({ level: 2 }) }"
              @click="commands.heading({ level: 2 })"
            >
              <span class="menububble-button-label">H2</span>
              <span class="menububble-button-sample h2">Heading 2</span>
            </button>

            <button
              class="menububble-button"
              :class="{ 'is-active': isActive.heading({ level: 3 }) }"
              @click="commands.heading({ level: 3 })"
            >
              <span class="menububble-button-label">H3</span>
              <span class="menububble-button-sample h3">Heading 3</span>
            </button>

            <button
              class="menububble-button"
              :class="{ 'is-active': isActive.heading({ level: 4 }) }"
              @click="commands.heading({ level: 4 })"
            >
              <span class="menububble-button-label">H4</span>
              <span class="menububble-button-sample h4">Heading 4</span>
            </button>

            <button
              class="menububble-button"
              :class="{ 'is-active': isActive.heading({ level: 5 }) }"
              @click="commands.heading({ level: 5 })"
            >
              <span class="menububble-button-label">H5</span>
              <span class="menububble-button-sample h5">Heading 5</span>
            </button>

            <button
              class="menububble-button"
              :class="{ 'is-active': isActive.heading({ level: 6 }) }"
              @click="commands.heading({ level: 6 })"
            >
              <span class="menububble-button-label">H6</span>
              <span class="menububble-button-sample h6">Heading 6</span>
            </button>

          </div>
        </div>
      </editor-menu-bubble>

    <editor-content class="editor__content" :editor="editor" />
  </div>
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBubble } from 'tiptap'
import { selectAll } from 'prosemirror-commands'
import {
  Heading,
  Bold,
  Italic,
  Blockquote,
  BulletList,
  OrderedList,
  CodeBlock,
  HardBreak,
  Image,

  ListItem,
  TodoItem,
  TodoList,
  Code,
  Link,
  Strike,
  Underline,
  History,

} from 'tiptap-extensions'
import Clipboard from "@/components/richEditor/Clipboard";
export default {
  name: "RichEditor",
  components: {
    EditorContent,
    EditorMenuBubble
  },
  props: ['initValue', 'isClipboardEnabled'],
  computed: {
  },
  data() {
    return {
      keepInBounds: true,
      displayDropDown: false,
      editor: new Editor({
        extensions: [
          new Clipboard(),
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3, 4, 5, 6,] }),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new Image(),
        ],
        commands() {
          () => selectAll
          // copy: () => this.copy(),
        },
        content: this.initValue,
        onUpdate: ({ getHTML, getJSON }) => {
          // get new content on update
          let clear = true
          getJSON().content.forEach(item => {
            if(item.content) {
              clear = false
            }
          });
          if(clear) {
            this.$emit('change', "")
          } else {
            this.$emit('change', getHTML())
          }
        },
      }),
      linkUrl: null,
      linkMenuIsActive: false,
    }
  },
  beforeDestroy() {
    this.editor.destroy()
  },
  methods: {
    showImagePrompt(command) {
      const src = prompt('Enter the url of your image here')
      if (src !== null) {
        command({ src })
      }
    },
    toggleDropdown() {
      this.displayDropDown = !this.displayDropDown;
    },
    showLinkMenu(attrs) {
      this.linkUrl = attrs.href
      this.linkMenuIsActive = true
      this.$nextTick(() => {
        this.$refs.linkInput.focus()
      })
    },
    hideLinkMenu() {
      this.linkUrl = null
      this.linkMenuIsActive = false
    },
    setLinkUrl(command, url) {
      command({ href: url })
      this.hideLinkMenu()
    },
    copyToClipboard() {
      this.editor.commands.selectAll()
      this.editor.commands.copy()
    }
  },

}
</script>

<style scoped>

</style>
